'use client';
import { type Brand } from '@curology/ui-components-web/brand';
import { Typography } from '@curology/ui-components-web/react';
import React, { useEffect, useState } from 'react';

import { CheckoutFooter } from '@/components/flow/expressCurologySignUpSkin/components/checkoutFooter';
import { PriceSummaryAccordion } from '@/components/flow/expressCurologySignUpSkin/components/priceSummaryAccordion';
import { type ExpressCurologySignUpSkinPdpSourceConfigType } from '@/components/flow/expressCurologySignUpSkin/types';
import { type TreatmentCategory } from '@/consts/treatmentCategories';
import { useRouter } from '@/hooks/useRouter';
import { getVisit, editSessionBag } from '@/services/visitsService/client';

import { CreateAccountForm } from './components/createAccountForm';
import { CreateAccountLinks } from './components/createAccountLinks';

export const ClientContainer = ({
  brand,
  bundleConfig,
  giftWithPurchaseImageUrl,
  treatmentCategory,
  uuid,
}: {
  brand: Brand;
  bundleConfig: ExpressCurologySignUpSkinPdpSourceConfigType;
  giftWithPurchaseImageUrl?: string;
  treatmentCategory: TreatmentCategory;
  uuid: string;
}) => {
  const [selectedAddOnProductItemIds, setSelectedAddOnProductItemIds] =
    useState<number[]>([]);

  const router = useRouter();

  useEffect(() => {
    const getCurrentVisit = async () => {
      const visit = await getVisit({ uuid });
      if (visit?.authenticated) {
        await editSessionBag({
          brand,
          sessionBag: {
            hasCreatedAccount: true,
            getDobOnLegalNamePage: true,
          },
          uuid,
        });
        router.refresh();
      }

      if (visit?.sessionBag?.selectedAddOnProductItemIds) {
        setSelectedAddOnProductItemIds(
          visit.sessionBag.selectedAddOnProductItemIds,
        );
      }

      if (visit?.sessionBag?.hasCreatedAccount) {
        router.refresh();
      }
    };

    const checkUrlParams = async () => {
      if (
        location.search.includes('createdAccountViaSocialSignIn=true') ||
        location.search.includes('loggedInViaSocialSignIn=true')
      ) {
        await editSessionBag({
          brand,
          sessionBag: {
            hasCreatedAccount: true,
          },
          uuid,
        });

        router.refresh();
      }
    };

    getCurrentVisit();
    checkUrlParams();
  }, [brand, uuid, router]);

  return (
    <React.Fragment>
      <PriceSummaryAccordion
        bundleConfig={bundleConfig}
        giftWithPurchaseImageUrl={giftWithPurchaseImageUrl}
        selectedAddOnProductItemIds={selectedAddOnProductItemIds}
      />
      <div className="cur-bg-surface-neutral cur-p-4">
        <Typography className="cur-mb-4" weight="bold">
          Create account
        </Typography>
        <CreateAccountForm
          brand={brand}
          offerId={bundleConfig.offerId}
          treatmentCategory={treatmentCategory}
          uuid={uuid}
        />
        <CreateAccountLinks />
      </div>
      <div className="cur-bg-surface-neutral cur-p-4">
        <Typography weight="bold">Payment method</Typography>
      </div>
      <div className="cur-bg-surface-neutral cur-p-4">
        <Typography weight="bold">Shipping address</Typography>
      </div>
      <CheckoutFooter
        bundleConfig={bundleConfig}
        selectedAddOnProductItemIds={selectedAddOnProductItemIds}
      />
    </React.Fragment>
  );
};
